import {
    Paper,
    Typography,
    Box,
    Stack,
    Chip,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Alert,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";
import PsychologyIcon from "@mui/icons-material/Psychology";
import SpeedIcon from "@mui/icons-material/Speed";
import { useState } from "react";

export default function MinigamesAnalysis() {
    const [filter, setFilter] = useState("all");

    const games = [
        {
            title: "Pacnij Kreta",
            difficulty: "easy",
            text: "Jedna z najlepiej ocenianych minigier. Większość zespołów osiągała wysoką skuteczność już po kilku próbach.",
        },
        {
            title: "Gra w 3 kubki",
            difficulty: "easy",
            text: "Wyzwanie wymagające koncentracji i pamięci wzrokowej. Dla wielu drużyn było jednym z najpewniejszych źródeł punktów.",
        },
        {
            title: "Tor wspinaczkowy",
            difficulty: "easy",
            text: "Większość uczestników osiągała dobre wyniki w krótkim czasie.",
        },
        {
            title: "Gdzie to jest?",
            difficulty: "hard",
            text: "Zadanie polegało na oznaczeniu miejsca na globusie.Jedno z największych wyzwań turnieju. Wymagało dokładności i dobrej orientacji.",
        },
        {
            title: "Trivia",
            difficulty: "hard",
            text: "Zadanie z Quizem. Liczyła się zarówno wiedza, jak i szybkie podejmowanie decyzji.",
        },
        {
            title: "Sudoku",
            difficulty: "hard",
            text: "Najbardziej logiczne z wyzwań. Trudne, ale dające satysfakcję po ukończeniu.",
        },
        {
            title: "Cztery Kształty",
            difficulty: "medium",
            text: "Pozornie proste zadanie wymagające spostrzegawczości.",
        },
        {
            title: "Muzyczny Refleks",
            difficulty: "medium",
            text: "Najlepiej radziły sobie osoby z dobrym wyczuciem rytmu.",
        },
        {
            title: "Kosmiczny tor przeszkód",
            difficulty: "hard",
            text: "O wyniku decydowały głównie umiejętności gracza.",
        },
        {
            title: "Wyzwanie Stolarza",
            difficulty: "hard",
            text: "Wyzwanie wymagające cierpliwości i dokładności.",
        },
    ];

    const filteredGames =
        filter === "all"
            ? games
            : games.filter((game) => game.difficulty === filter);

    const easy = games.filter((g) => g.difficulty === "easy").length;
    const medium = games.filter((g) => g.difficulty === "medium").length;
    const hard = games.filter((g) => g.difficulty === "hard").length;

    const difficultyConfig = {
        easy: {
            label: "Łatwa",
            color: "success",
            border: "#22c55e",
        },
        medium: {
            label: "Średnia",
            color: "warning",
            border: "#f59e0b",
        },
        hard: {
            label: "Trudna",
            color: "error",
            border: "#ef4444",
        },
    };

    return (
        <Paper
            elevation={0}
            sx={{
                p: 3,
                borderRadius: 4,
                border: "1px solid",
                borderColor: "divider",
                height: "100%",
                backgroundColor: "#294e6b",
            }}
        >

            <Typography
                variant="overline"
                sx={{
                    color: "#fff",
                    fontWeight: 700,
                    letterSpacing: 1.5,
                }}
            >
                ANALIZA MINIGIER
            </Typography>

            <Typography
                variant="h5"
                sx={{
                    fontWeight: 700,
                    mb: 2,
                    color: "#fff"
                }}
            >
                Jak uczestnicy poradzili sobie z wyzwaniami?
            </Typography>

            <Alert
                severity="info"
                sx={{
                    mb: 3,
                    borderRadius: 3,
                }}
            >
                Uczestnicy najlepiej radzili sobie z wyzwaniami opartymi na
                refleksie i spostrzegawczości. Największym wyzwaniem okazały się
                minigry logiczne wymagające analizy, planowania i cierpliwości.
            </Alert>

            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(3, 1fr)",
                    gap: 2,
                    mb: 3,
                }}
            >
                <Paper
                    variant="outlined"
                    sx={{
                        p: 3,
                        borderRadius: 4,
                        position: "relative",
                        overflow: "hidden",
                        minHeight: 180,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        bgcolor: "success.50",
                    }}
                >
                    <SpeedIcon
                        sx={{
                            position: "absolute",
                            fontSize: 180,
                            color: "success.main",
                            opacity: 0.12,
                        }}
                    />

                    <Stack
                        spacing={0.5}
                        alignItems="center"
                        sx={{ position: "relative", zIndex: 1 }}
                    >
                        <Typography
                            variant="h2"
                            fontWeight={800}
                            color="success.main"
                            lineHeight={1}
                        >
                            {easy}
                        </Typography>

                        <Typography
                            variant="h6"
                            fontWeight={600}
                            color="success.main"
                            textTransform="uppercase"
                            letterSpacing={2}
                        >
                            Łatwe
                        </Typography>
                    </Stack>
                </Paper>

                <Paper
                    variant="outlined"
                    sx={{
                        p: 3,
                        borderRadius: 4,
                        position: "relative",
                        overflow: "hidden",
                        minHeight: 180,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        bgcolor: "warning.50",
                    }}
                >
                    <SportsEsportsIcon
                        sx={{
                            position: "absolute",
                            fontSize: 180,
                            color: "warning.main",
                            opacity: 0.12,
                        }}
                    />

                    <Stack
                        spacing={0.5}
                        alignItems="center"
                        sx={{ position: "relative", zIndex: 1 }}
                    >
                        <Typography
                            variant="h2"
                            fontWeight={800}
                            color="warning.main"
                            lineHeight={1}
                        >
                            {medium}
                        </Typography>

                        <Typography
                            variant="h6"
                            fontWeight={600}
                            color="warning.main"
                            textTransform="uppercase"
                            letterSpacing={2}
                        >
                            Średnie
                        </Typography>
                    </Stack>
                </Paper>

                <Paper
                    variant="outlined"
                    sx={{
                        p: 3,
                        borderRadius: 4,
                        position: "relative",
                        overflow: "hidden",
                        minHeight: 180,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        bgcolor: "error.50",
                    }}
                >
                    <PsychologyIcon
                        sx={{
                            position: "absolute",
                            fontSize: 180,
                            color: "error.main",
                            opacity: 0.12,
                        }}
                    />

                    <Stack
                        spacing={0.5}
                        alignItems="center"
                        sx={{ position: "relative", zIndex: 1 }}
                    >
                        <Typography
                            variant="h2"
                            fontWeight={800}
                            color="error.main"
                            lineHeight={1}
                        >
                            {hard}
                        </Typography>

                        <Typography
                            variant="h6"
                            fontWeight={600}
                            color="error.main"
                            textTransform="uppercase"
                            letterSpacing={2}
                        >
                            Trudne
                        </Typography>
                    </Stack>
                </Paper>
            </Box>

            <Stack
                direction="row"
                spacing={1}
                sx={{
                    mb: 3,
                    flexWrap: "wrap",
                }}
            >
                <Chip
                    label="Wszystkie"
                    clickable
                    color={filter === "all" ? "primary" : "default"}
                    onClick={() => setFilter("all")}
                    sx={{
                        color: "#fff",
                    }}
                />

                <Chip
                    label="Łatwe"
                    clickable
                    color={filter === "easy" ? "success" : "default"}
                    onClick={() => setFilter("easy")}
                    sx={{
                        color: "#fff",
                    }}
                />

                <Chip
                    label="Średnie"
                    clickable
                    color={filter === "medium" ? "warning" : "default"}
                    onClick={() => setFilter("medium")}
                    sx={{
                        color: "#fff",
                    }}
                />


                <Chip
                    label="Trudne"
                    clickable
                    color={filter === "hard" ? "error" : "default"}
                    onClick={() => setFilter("hard")}
                    sx={{
                        color: "#fff",
                    }}
                />
            </Stack>

            {filteredGames.map((game) => {
                const config = difficultyConfig[game.difficulty];

                return (
                    <Accordion
                        key={game.title}
                        disableGutters
                        elevation={0}
                        sx={{
                            mb: 1,
                            borderRadius: "12px !important",
                            overflow: "hidden",
                            border: "1px solid",
                            borderColor: "divider",
                            borderLeft: `5px solid ${config.border}`,
                            "&:before": {
                                display: "none",
                            },
                        }}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                        >
                            <Stack
                                direction="row"
                                spacing={1}
                                alignItems="center"
                            >
                                <Typography fontWeight={600}>
                                    {game.title}
                                </Typography>

                                <Chip
                                    size="small"
                                    label={config.label}
                                    color={config.color}
                                />
                            </Stack>
                        </AccordionSummary>

                        <AccordionDetails>
                            <Typography
                                variant="body2"
                                color="text.secondary"
                            >
                                {game.text}
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                );
            })}
        </Paper>
    );
}